import PortableText from "components/PortableText"
import { urlForImage } from "lib/sanity.image"
import { HorizontalCardsItem } from "schemas"
import { HStack, styled, VStack } from "styled-system/jsx"
import { square } from "styled-system/patterns"

type Props = HorizontalCardsItem

function HorizontalCardsItem({ title, content, image }: Props) {
  return (
    <HStack
      gap={9}
      css={{
        maxW: "530px",
        py: 10,
        px: 5,
        bg: "white",
        rounded: "20px",
        filter: "drop-shadow(0px 7px 24px rgba(0, 0, 0, 0.10))",
        color: "other.1",
      }}>
      {image && (
        <img
          alt={image.alt || ""}
          src={urlForImage(image).width(400).url()}
          className={square({
            mx: -5,
            // maxW: "120px",
          })}
        />
      )}

      <VStack gap={4}>
        <styled.h3
          css={{
            color: "#000A3A",
            fontFamily: "heading",
            fontSize: "20px",
            fontStyle: "normal",
            fontWeight: "600",
            lineHeight: "150%",
            letterSpacing: "-0.38px",
          }}>
          {title}
        </styled.h3>

        <styled.div>
          <PortableText className={"x"} value={content} />
        </styled.div>
      </VStack>
    </HStack>
  )
}

export default HorizontalCardsItem
export type { Props as HorizontalCardsItemProps }
